import { render } from "./TablaViviendas.vue?vue&type=template&id=f5e06c52"
import script from "./TablaViviendas.vue?vue&type=script&lang=js"
export * from "./TablaViviendas.vue?vue&type=script&lang=js"

import exportComponent from "/home/jean/lienzo/quinta_amelia_dashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__